"use client";

import {
  CORE_VALUES,
  FEATURED,
} from "@/utils/constants";
import Image from "next/image";
import LandingPageLayout from "@/components/layout/LandingPageLayout";
import ModalComponent from "@/components/ui/modal";
import { DownloadBtns, Popup } from "@/components/ui/popup";

const Home = () => {

  return (
    <>
      {" "}
      <LandingPageLayout>
        <main className="lg:pt-20 md:pt-12 pt-6">
          <div className="lg:px-20 md:px-12 px-6 flex flex-col md:flex-row md:gap-12 lg:gap-20 gap-4 h-full">
            <section className="space-y-4 text-left">
              <h1 className="font-bold text-3xl lg:text-7xl leading-[48px] lg:leading-[90px]">
                Your Co-operative <br/>Now In Your Pocket
              </h1>
              <p className="text-sm md:text-base lg:text-lg">
                Manage your cooperative contributions, savings and loans effortlessly using Monietab. Stay connected, get full transparency, 
                instant access, and total control right from your phone.
              </p>
              <DownloadBtns />
            </section>
            <section className="space-y-4 w-full md:w-1/2 items-center md:items-start justify-center ">
              <Image
                alt="Hand showing Monietab App" 
                src={'/hero.svg'}
                width={400}
                height={100}
                objectFit="cover"
                className="pb-0"
              />
            </section>
          </div>

          <section className="flex flex-col items-center gap-6 lg:gap-8 px-6 py-8 md:py-6 bg-white">
            <h2 className="text-xl lg:text-2xl font-bold">As Featured In</h2>
            <div className="flex justify-evenly gap-4 w-full overflow-y-scroll hide-scrollbar scroll-smooth">
              {FEATURED.map((icon, index) => (
                <Image key={index} src={icon} alt="Partner logo" />
              ))}
            </div>
          </section>

          <section className="w-full bg-black mx-auto p-6 lg:px-40 lg:py-20 md:px-12 md:space-y-8 space-y-6 text-white">
            <h2 className="font-medium text-2xl md:text-3xl text-center leading-[47px]">
              What is <span className="font-bold">Monietab</span>?
            </h2>
            <p className="font-normal text-lg md:text-3xl text-center md:leading-[47px]">
              Monietab is the all-in-one digital platform that connects you directly with your 
              cooperative society. No more manual ledgers. long queues, or guesswork. 
              We&apos;ve built a secure and simple app that puts your cooperative&apos;s 
              activities at your fingertips.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {CORE_VALUES.map(({ title, description, icon }, index) => (
                <div
                  key={index}
                  className="bg-white text-black p-6 py-12 rounded-lg space-y-4"
                >
                  <Image
                    src={icon}
                    alt={`${title} icon`}
                    width={50}
                    height={50}
                  />
                  <h3 className="font-semibold text-2xl">{title}</h3>
                  <p className="text-sm md:text-base">{description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* <section className="flex flex-col gap-6 md:gap-8 items-center px-6 lg:px-40 md:px-12 py-12 lg:py-20 w-full bg-[#ffffff]">
            <h2 className="font-bold text-lg lg:text-3xl text-center">
              How Monietab Gamifies Savings
            </h2>
            <div className="border border-opacity-30 rounded-[20px] p-2 w-full">
              <iframe
                width="560"
                height="400"
                src="https://www.youtube.com/embed/a4ogMc5SVS4?si=nt48kfj0r7PNdOiY"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="w-full rounded-[20px] lg:h-[400px] md:h-[250px] h-[180px]"
              ></iframe>
            </div>
          </section> */}

          {/* <section className="md:space-y-8 space-y-6 md:px-12 py-12 lg:py-20 lg:px-20 px-6">
            <h2 className="font-bold text-xl lg:text-3xl text-center">
              How it Works
            </h2>
            <div className="flex flex-col justify-between md:flex-row gap-6">
              <div className="space-y-4 md:w-1/2 w-full">
                {LANDING_ACCORDION_ITEMS.map(({ details, summary }, index) => (
                  <div key={index}>
                    <Accordion
                      className="bg-[#ffffff]"
                      expanded={expanded === `panel1-${index}`}
                      onChange={handleAccordionChange(`panel1-${index}`, index)}
                    >
                      <AccordionSummary
                        expandIcon={<ArrowDropDownIcon />}
                        aria-controls={summary}
                        id={`accordion-${index}`}
                      >
                        <p className="font-semibold flex items-center gap-2">
                          <span>{index + 1}.</span>
                          <span>{summary}</span>
                        </p>
                      </AccordionSummary>
                      <AccordionDetails>
                        <p className="text-sm">{details}</p>
                      </AccordionDetails>

                      {index === newIndex && (
                        <Image
                          src={ACCORDION_IMAGE[newIndex]}
                          alt="Phone illustration"
                          width={350}
                          height={350}
                          className="md:hidden block"
                        />
                      )}
                    </Accordion>
                  </div>
                ))}
              </div>

              {expanded === `panel1-${newIndex}` && (
                <div className="bg-[#ffffff] hidden md:block">
                  <Image
                    src={ACCORDION_IMAGE[newIndex]}
                    alt="Phone illustration"
                    width={350}
                    height={350}
                  />
                </div>
              )}
            </div>
          </section> */}

          {/* <section className="bg-[#0F0326] px-6 py-12  lg:py-20 lg:px-20 md:px-12 text-white">
            <div className="flex flex-col md:flex-row gap-4 justify-between items-center md:items-start">
              <div className="md:w-1/2 space-y-4">
                <Image src="/ssl.svg" alt="SSL logo" width={132} height={27} />
                <h2 className="font-bold text-3xl leading-[48px] lg:text-5xl lg:leading-[70px]">
                  Keeping your money safe is our priority.
                </h2>
                <p className="text-sm lg:text-base ">
                  Ensuring the safety of your funds and the security of your
                  account is our top priority. We employ advanced Internet
                  Security protocols, including 256-bit SSL encryption.
                </p>
                <Link
                  href="/security"
                  className="md:text-base text-xs items-center flex gap-2 font-medium"
                >
                  Learn more about our security measures
                  <BsArrowRight size={20} />
                </Link>
              </div>
              <Image
                src="/security.svg"
                alt="Security illustration"
                width={300}
                height={300}
              />
            </div>
          </section> */}
        </main>
      </LandingPageLayout>
      {/* pop up */}
      <ModalComponent modalId="downloadMobile" borderRadius="20px">
        <Popup />
      </ModalComponent>
    </>
  );
};

export default Home;
